import { useEffect, useState } from "react";
import { Link } from "react-router-dom";
import { Button } from "@/components/ui/button";
import { Cookie, X } from "lucide-react";

const STORAGE_KEY = "hamn_cookie_consent";

export default function CookieConsent() {
  const [visible, setVisible] = useState(false);

  useEffect(() => {
    if (!localStorage.getItem(STORAGE_KEY)) {
      const t = setTimeout(() => setVisible(true), 600);
      return () => clearTimeout(t);
    }
  }, []);

  useEffect(() => {
    // Reservera utrymme så bannern aldrig täcker sidans knappar (särskilt på mobil).
    document.body.style.paddingBottom = visible ? "260px" : "";
    return () => { document.body.style.paddingBottom = ""; };
  }, [visible]);

  const accept = () => {
    localStorage.setItem(STORAGE_KEY, JSON.stringify({ accepted: true, at: new Date().toISOString() }));
    setVisible(false);
  };

  if (!visible) return null;

  return (
    <div
      className="fixed inset-x-0 bottom-0 z-40 p-3 sm:p-5 animate-in slide-in-from-bottom duration-500 pointer-events-none"
      data-testid="cookie-consent"
    >
      <div className="mx-auto max-w-3xl rounded-2xl border border-border bg-white/95 backdrop-blur-xl shadow-xl p-5 sm:p-6 pointer-events-auto">
        <div className="flex items-start gap-4">
          <div className="hidden sm:flex h-11 w-11 shrink-0 items-center justify-center rounded-xl bg-primary/10 text-primary">
            <Cookie className="h-5 w-5" />
          </div>
          <div className="flex-1 min-w-0">
            <h3 className="font-head font-semibold text-base flex items-center gap-2">
              <Cookie className="h-4 w-4 text-primary sm:hidden" /> Kakor (cookies) på HAMN
            </h3>
            <p className="text-sm text-muted-foreground mt-1.5 leading-relaxed">
              HAMN använder endast <strong>nödvändig lokal lagring</strong> för att hålla dig inloggad. Vi använder
              inga kakor för analys, spårning eller marknadsföring. Läs mer i vår{" "}
              <Link to="/integritetspolicy" className="text-primary font-medium underline underline-offset-2" data-testid="cookie-more-link">
                integritetspolicy
              </Link>.
            </p>
            <div className="mt-4 flex flex-wrap items-center gap-2">
              <Button className="rounded-full" onClick={accept} data-testid="cookie-accept-btn">
                Acceptera
              </Button>
            </div>
          </div>
          <button
            onClick={accept}
            className="flex h-11 w-11 items-center justify-center -mr-2 -mt-2 text-muted-foreground hover:text-foreground shrink-0"
            aria-label="Stäng"
            data-testid="cookie-close-btn"
          >
            <X className="h-5 w-5" />
          </button>
        </div>
      </div>
    </div>
  );
}
